import React, { useEffect, useMemo } from "react";
import dynamic from "next/dynamic";
import { useDispatch, useSelector } from "react-redux";
import { actions as modalActions } from "@/bit/reducers/next13.reducers.modals-reducer";
import { actions as mainActions } from "@/bit/reducers/next13.reducers.main-reducer";
import getDeviceKindDependsOnViewPort from "@gerenciatd/next13.utils.common.get-device-kind-depends-on-viewport";
import { whichAnimationEvent } from "./utils";
import PriceModule from "./price-module";
import ActionCallModule from "./action-call-module";
import LegalModule from "./legal-module";
import C2CModule from "./c2c-module";

function BuyBox(props) {
  const dispatch = useDispatch();
  const { zone, cpModalClosed, refreshZone, logged } = useSelector(
    (state) => state.main
  );

  const product = useMemo(
    () =>
      props["Product-2"] && zone === "ZR"
        ? props["Product-2"]
        : props["Product-1"],
    [zone && cpModalClosed]
  );

  const skeletonClassName = zone || !props["Product-2"] ? "noanimated" : "";

  const buttonHref = product["Button-1"]?.href
    ? product["Button-1"]?.href
    : logged
    ? product["Button-1"].urlLinkclient
    : product["Button-1"].urlLinknoclient;

  const showModalLegalHandler = () => {
    const LegalModal = dynamic(() => import("./modals/legal"));

    dispatch(
      modalActions.addModal({
        id: "legal-modal",
        Element2Show: LegalModal,
        modalProps: {
          closeIdByClickingOutside: "closeAll",
          contentPosition: "right--top",
          opacityLayoutColor: "blur",
          inSceneEffect: "fadeIn",
          contentInsideContainer: false,
          outSceneEffect: "fadeOut",
          closeByClickingOutside: true,
          scrollAllowed: false,
          createAnchor: false,
        },
        elementProps: {
          title: product["Legal-1"]?.["Text-1"] || "",
          description: product["Legal-1"]?.["Text-2"] || "",
        },
      })
    );
  };

  const changeZoneModalHandler = () => {
    const BuyBoxModal = dynamic(() => import("./modals/zone-change"));
    const device = getDeviceKindDependsOnViewPort();

    dispatch(
      modalActions.addModal({
        id: "cnmc",
        Element2Show: BuyBoxModal,
        modalProps: {
          contentPosition:
            device !== "MOBILE" ? "center--center" : "center--bottom",
          opacityLayoutColor: "blur",
          inSceneEffect: "fadeIn",
          contentInsideContainer: false,
          outSceneEffect: "fadeOut",
          closeByClickingOutside: true,
          scrollAllowed: false,
        },
        elementProps: {},
      })
    );
  };

  const onChangeZone = () => {
    const transitionEvent = whichAnimationEvent();
    const element = document.getElementById("animationReference");

    if (transitionEvent) {
      element.addEventListener(transitionEvent, () => {
        setTimeout(() => {
          changeZoneModalHandler();
        }, 100);
      });
    }
  };

  useEffect(() => {
    if (refreshZone && props["Product-2"]) {
      onChangeZone();
    }

    dispatch(mainActions.setZoneRefreshFlag(false));
  }, [product && refreshZone && cpModalClosed]);

  return (
    <div className="buy-box">
      <div className="buy-box-content">
        <PriceModule
          prePriceText={product["Text-0"]}
          topLabel={product["Label-1"]}
          mainPrice={product["Price-2"]}
          secondaryPrice={product["Price-1"]}
          postPriceText={product["Text-1"]}
          secondaryText={product["Text-2"]}
          skeletonClassName={skeletonClassName}
        />
        <ActionCallModule
          simplePhone={props["simplePhone"]}
          button={{ ...product["Button-1"], href: buttonHref }}
          skeletonClassName={skeletonClassName}
        />
        {props["simplePhone"]?.["Text-3"] && (
          <C2CModule textLink={props["simplePhone"]["Text-3"]} />
        )}
      </div>
      <LegalModule
        button={product["Button-2"]}
        onClick={showModalLegalHandler}
        text={product["Text-4"]}
        skeletonClassName={skeletonClassName}
      />
      <style jsx global>{`.buy-box {
  position: relative;
  border: 1px solid rgb(221, 221, 221);
  border-radius: 8px;
  padding: 1rem;
  .buy-box-content {
    display: flex;
    align-items: flex-start;
    flex-direction: column;
    flex-wrap: wrap;
    justify-content: space-between;

    .call-to-action {
      width: 100%;

      display: flex;
      flex-flow: column-reverse;
      margin-top: 1.5rem;
      align-items: center;
      gap: 1rem;

      .simple-phone-component {
        flex: 1;
        width: 100%;

        .mainPhoneCTA {
          .mobile {
            display: inline-block;
            margin: 0.2rem;
          }
          .mobile-button-full {
            display: block;
          }

          .action-container {
            display: inline;
          }
        }
      }

      .principal-button {
        width: 100%;
      }
    }

    .text.label {
      display: inline;
      margin-bottom: 0.5rem;
    }

    .buy-box-content-price {
      display: flex;
      flex-direction: column;
      gap: 0.5rem;
      .text-claim {
        margin-bottom: .8rem;
      }
      .price--content {
        font-size: 28px !important;
      }
      .price--currency {
        font-size: 18px !important;
      }
      .price--quote_text {
        font-size: 18px !important;
      }
    }
    .buy-box-content-price_flex {
      display: flex;
      gap: 0.5rem;
    }
    .buy-box-content-text {
      display: flex;
      gap: 0.5rem;
    }
    .buy-box-content-button {
      width: 100%;
    }
    .buy-box-content-button-full {
      margin-top: 0;
      max-width: 22rem;
      margin-left: auto;
      margin-right: auto;
    }

    .container-C2C {
      display: flex;
      align-items: baseline;
      gap: 0.3rem;
      margin-top: 0.5rem;
    }
  }
  .buy-box-legal {
    &.with-pre-legals {
      padding-top: 1rem;
    }
    .pre-legals {
      font-size: 0.875rem !important;
    }
    .legal-button {
      justify-content: flex-start;
      padding: 0;
    }
  }
  hr.separator {
    color: #dddddd;
    margin-top: 10px;
  }
  .buy-box-legal {
    a {
      display: block;
      text-align: left;
      padding: 0;
    }
  }
}

@media screen and (min-width: 868px) {
  .buy-box {
    .buy-box-content {
      .call-to-action {
        flex-flow: row;
        gap: 0;

        .principal-button {
          width: 178px;
        }

        .simple-phone-component {
          .mainPhoneCTA {
            .mobile {
              display: none;
            }

            .mobile-button-full {
              display: none;
            }

            & > .desktop {
              .text {
                font-size: clamp(0.5rem, 1.5vw, 1rem);
              }
            }
          }
        }

        .buy-box-content-button {
          flex: 1;
        }
      }
    }

    hr.separator {
      color: #dddddd;
      margin-top: 25px;
    }
  }
}

@media screen and (min-width: 1280px) {
  .buy-box {
    .buy-box-content {
      flex-direction: row;
      align-items: flex-end;

      .call-to-action {
        flex-flow: row;
        justify-content: flex-end;
        &.phone-below-price {
          flex: auto;
          gap: 1rem;
        }

        &.phone-normal {
          flex: 0;
        }

        .simple-phone-component {
          min-width: 180px;
          flex: 0;
        }

        .buy-box-content-button {
          flex: 0.5rem;
          margin-top: 0;

          min-width: 10.8rem;
        }
      }
    }
    hr.separator {
      color: #dddddd;
      margin-top: 25px;
    }
  }
}`}</style>
    </div>
  );
}

export default BuyBox;
